import { Fragment, StrictMode } from 'react'
import type { VFC } from 'react'
import { StoryfirstUnit, storyfirstUnits } from '@opallabs/concepts'
import type { StoryfirstUnitValue } from '@opallabs/concepts'
import { capitalCase } from '@opallabs/lambda'
import * as styles from './styles'
import type { PopoverContentProps } from './types'

const labels = (context: StoryfirstUnitValue) => {
  let budget: StoryfirstUnitValue = StoryfirstUnit.Story
  const allocations: StoryfirstUnitValue[] = [StoryfirstUnit.Content]

  if (context === StoryfirstUnit.Moment) {
    budget = context
  } else {
    allocations.unshift(StoryfirstUnit.Moment)
  }

  return [
    storyfirstUnits`${budget} Budget`,
    ...allocations.map(
      (allocation) => storyfirstUnits`${allocation} Allocation`
    ),
  ]
}

const descriptions = (context: StoryfirstUnitValue) => {
  let parts: string[]

  if (context === StoryfirstUnit.Moment) {
    parts = [
      storyfirstUnits`available to allocate to ${StoryfirstUnit.Content}`,
      storyfirstUnits`that is already allocated to ${StoryfirstUnit.Contents} in this ${StoryfirstUnit.Moment}`,
    ]
  } else {
    parts = [
      [
        storyfirstUnits`available to allocate to ${StoryfirstUnit.Moments}`,
        storyfirstUnits`and ${StoryfirstUnit.Contents}`,
        storyfirstUnits`in this ${StoryfirstUnit.Story}`,
      ].join(' '),
      storyfirstUnits`that is already allocated to ${StoryfirstUnit.Moments} in this ${StoryfirstUnit.Story}`,
      storyfirstUnits`that is already allocated to ${StoryfirstUnit.Contents} in this ${StoryfirstUnit.Story}`,
    ]
  }

  return parts
}

export const PopoverContent: VFC<PopoverContentProps> = ({
  context,
  theme,
}) => {
  const contextualLabels = labels(context)
  const contextualDescriptions = descriptions(context)

  return (
    <StrictMode>
      <dl css={styles.infoPopoverContent({ theme })}>
        {contextualLabels.map((label, index) => (
          <Fragment key={index}>
            <dt css={styles.infoPopoverLabel({ theme })}>
              {capitalCase(label)}
            </dt>
            <dd css={styles.infoPopoverText}>
              The total amount of budget {contextualDescriptions[index]}
            </dd>
          </Fragment>
        ))}
      </dl>
    </StrictMode>
  )
}
PopoverContent.displayName = 'Photon: PopoverContent ← BudgetHeader'
